<div class="width-1200">

  <mat-card>

    <mat-toolbar class="toolbar-top">

      <div class='title'>
        <mat-icon>hourglass_top</mat-icon>
        <div style='font-size: 17px;'>
          Lista de Espera
        </div>

      </div>

    </mat-toolbar>

  </mat-card>


  <mat-card class='header-select'>

    <mat-select (ngModelChange)='selectByProduct($event)' [ngModel]='selectedProduct.id'
      placeholder="Selecione um produto">
      <mat-option *ngFor="let product of products" [value]="product.id">
        {{ product.name }}
      </mat-option>
    </mat-select>

    <a mat-button (click)="exportCSV()" style='width:60px;' *ngIf="dataSource">
      <mat-icon color='primary'>download</mat-icon>
    </a>

  </mat-card>


  <mat-card>

    <!-- TABLE -->
    <mat-table [dataSource]="dataSource" matSort matSortActive="createdAt" matSortDirection='desc'
      matSortDisableClear=true>

      <!-- Icon Column -->
      <ng-container matColumnDef="icon">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-icon style='font-size:1.2em; margin-top:10px;'>hourglass_top</mat-icon>
        </mat-cell>
      </ng-container>

      <!-- date Column -->
      <ng-container matColumnDef="date">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Data </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span *ngIf="element.createdAt">{{ element.createdAt | date: 'dd/MM/yyyy - hh:mm a' }}</span>
        </mat-cell>
      </ng-container>

      <!-- Member Column -->
      <ng-container matColumnDef="member">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Usuário </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div style="display: flex; flex-direction:column;">
            <div>
              {{ element.member_name }}
            </div>
          </div>
        </mat-cell>
      </ng-container>

            <!-- Member Column -->
            <ng-container matColumnDef="category">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Usuário </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <div style="display: flex; flex-direction:column;">
                  <div>
                    <i>{{ element.category_name }}</i>
                  </div>
                </div>
              </mat-cell>
            </ng-container>

      <!-- waiting Column 
            <ng-container matColumnDef="waiting">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Espera </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{ element.waiting }} </mat-cell>
            </ng-container>
            -->

      <!-- allowed Column -->
      <ng-container matColumnDef="allowed">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Liberado </mat-header-cell>
        <mat-cell *matCellDef="let element">

          <span *ngIf='element.allowed'>
            <img src='/assets/images/status/img_green.png'>
          </span>

          <span *ngIf='!element.allowed'>
            <img src='/assets/images/status/img_silver.png'>
          </span>

        </mat-cell>
      </ng-container>

      <!-- edit Column -->
      <ng-container matColumnDef="edit">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button (click)='openDialog(element)' style='background-color: whitesmoke;'>
            <mat-icon class='icon-info' style='font-size:1.5em;'>
              info_outline
            </mat-icon>
          </a>
        </mat-cell>
      </ng-container>

      <!-- Header -->
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

      <!-- Row -->
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    </mat-table>
    <!-- END TABLE -->

  </mat-card>

</div>